import * as yup from "yup";

export const addTransportationCombutionValidation = yup.object({
  description: yup.string().required("Description is required"),
  category: yup.string().required("Category is required"),
  emissionFactorDataset: yup
    .string()
    .required("Emission factor dataset is required"),
  activityType: yup.string().required("Activity type is required"),
  year: yup.string().required("Year is required"),
  modeOfTransport: yup.string().required("Mode of transport is required"),
  amount: yup
    .number()
    .typeError("Amount of activity must be a valid number")
    .required("Amount of activity type is required")
    .strict(true),
  unit: yup.string().required("Unit of fuel is required"),
  month: yup.string().required("Month is required"),
});
